/*
  Delune: per-shade photo galleries. On a product with shades, a photo whose file name or alt text carries a
  shade's name (e.g. "delune_lip_balm_butter_cake_cloud_1.jpg"), or that is set as a variant's image, belongs to
  that shade; it only shows while that shade is selected. Photos that name no shade show for every shade.
  The data comes from sections/main-product.liquid (script[data-delune-shade-gallery]).
*/
(function () {
  const source = document.querySelector('script[data-delune-shade-gallery]');
  if (!source) return;

  let data;
  try {
    data = JSON.parse(source.textContent);
  } catch (e) {
    return;
  }

  const section = document.getElementById(`MainProduct-${data.section}`) || document;
  const owners = {}; // media id -> variant ids it belongs to
  let any = false;

  // Shopify's handleize keeps underscores ("..._sugar_kiss_1.jpg" -> "sugar_kiss") while shade names become
  // "sugar-kiss", so compare both with underscores and spaces read as hyphens.
  const norm = (s) => String(s || '').toLowerCase().replace(/[_\s]+/g, '-');
  data.media.forEach((media) => {
    const key = norm(media.key);
    const mine = data.variants
      .filter((variant) => variant.media === media.id || (variant.key.length > 3 && key.includes(norm(variant.key))))
      .map((variant) => variant.id);
    if (mine.length) {
      owners[media.id] = mine;
      any = true;
    }
  });
  if (!any) return;

  const style = document.createElement('style');
  style.textContent = '.delune-shade-hidden{display:none !important}';
  document.head.appendChild(style);

  function mediaId(el) {
    const raw = el.dataset.mediaId || el.dataset.target || '';
    return Number(raw.split('-').pop());
  }

  function apply(variantId) {
    if (!variantId) return;
    const variant = data.variants.find((item) => item.id === variantId);
    const lead = new Map(); // list -> the selected shade's own photos in it
    section
      .querySelectorAll(
        'media-gallery [data-media-id], media-gallery [data-target], .product-media-modal__content > [data-media-id]'
      )
      .forEach((el) => {
        const mine = owners[mediaId(el)];
        el.classList.toggle('delune-shade-hidden', Boolean(mine) && !mine.includes(variantId));
        if (mine && mine.includes(variantId) && el.parentElement) {
          if (!lead.has(el.parentElement)) lead.set(el.parentElement, []);
          lead.get(el.parentElement).push(el);
        }
      });
    // The shade's own photos come first (its main photo, then the rest), the shared ones after
    lead.forEach((items, list) => {
      items.sort((a, b) => (mediaId(b) === (variant && variant.media)) - (mediaId(a) === (variant && variant.media)));
      if (items.every((el, index) => list.children[index] === el)) return;
      list.prepend(...items);
    });
    section.querySelectorAll('media-gallery slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  let current = data.selected;
  apply(current);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data && event.data.variant;
      if (!variant || (event.data.sectionId && event.data.sectionId !== data.section)) return;
      current = variant.id;
      apply(current);
      // The theme reorders the photos after this event; go over them once it has
      setTimeout(() => apply(current), 60);
      setTimeout(() => apply(current), 400);
    });
  }
})();
